import React from 'react'

const Home = (): JSX.Element => (
  <div>
    <p>Welcome to Back Office v2 write in ReactJS</p>
  </div>
)

export default Home
